<template>
  <div ref="element">
    <div class="simplebar-wrapper">
      <div class="simplebar-height-auto-observer-wrapper">
        <div class="simplebar-height-auto-observer" />
      </div>
      <div class="simplebar-mask">
        <div class="simplebar-offset">
          <div
            ref="scrollElement"
            class="simplebar-content-wrapper"
            @scroll="$emit('scroll', $event)"
          >
            <div ref="contentElement" class="simplebar-content">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
      <div class="simplebar-placeholder" />
    </div>
    <div class="simplebar-track simplebar-horizontal">
      <div class="simplebar-scrollbar" />
    </div>
    <div class="simplebar-track simplebar-vertical">
      <div class="simplebar-scrollbar" />
    </div>
  </div>
</template>

<script>
import SimpleBar from "simplebar";

export default {
  name: "SimplebarVue",

  data() {
    return {
      isMounted: false
    };
  },

  computed: {
    scrollElement() {
      if (!this.isMounted) return null;

      return this.$refs.scrollElement;
    },
    contentElement() {
      if (!this.isMounted) return null;

      return this.$refs.contentElement;
    }
  },

  mounted() {
    const options = SimpleBar.getOptions(this.$refs.element.attributes);
    this.SimpleBar = new SimpleBar(this.$refs.element, options);

    this.isMounted = true;
  }
};
</script>
